/**
 * Cloud Functions URL Configuration
 *
 * URLs are built from environment variables to avoid hardcoding.
 * Set these in GitHub Secrets for CI/CD builds:
 * - REACT_APP_FUNCTIONS_V2_BASE: Cloud Run base (e.g., "yhplzf2nqq-uc.a.run.app")
 * - REACT_APP_FUNCTIONS_V1_BASE: Cloud Functions base (e.g., "us-central1-mind-habit-tracker.cloudfunctions.net")
 */

// Base URLs from environment
const V2_BASE = process.env.REACT_APP_FUNCTIONS_V2_BASE || '';
const V1_BASE = process.env.REACT_APP_FUNCTIONS_V1_BASE || '';

// Validation - warn in development if not configured
if (process.env.NODE_ENV === 'development' && (!V2_BASE || !V1_BASE)) {
  console.warn(
    '[Functions Config] Missing environment variables. Set REACT_APP_FUNCTIONS_V2_BASE and REACT_APP_FUNCTIONS_V1_BASE in .env.local'
  );
}

/**
 * Build a V2 Cloud Run function URL
 * Pattern: https://<functionname>-<base>.a.run.app
 * @param {string} functionName - lowercase function name (e.g., "createcheckoutsession")
 */
const v2Url = (functionName) => {
  if (!V2_BASE) {
    console.error(`[Functions] V2_BASE not configured for function: ${functionName}`);
    return '';
  }
  return `https://${functionName}-${V2_BASE}`;
};

/**
 * Build a V1 Cloud Functions URL
 * Pattern: https://<base>/<functionName>
 * @param {string} functionName - camelCase function name (e.g., "disableDailyRemindersForAll")
 */
const v1Url = (functionName) => {
  if (!V1_BASE) {
    console.error(`[Functions] V1_BASE not configured for function: ${functionName}`);
    return '';
  }
  return `https://${V1_BASE}/${functionName}`;
};

/**
 * All Cloud Function URLs organized by feature
 */
export const FUNCTION_URLS = {
  // Stripe (V2)
  stripe: {
    createCheckoutSession: v2Url('createcheckoutsession'),
    createPortalSession: v2Url('createportalsession'),
    getSubscriptionStatus: v2Url('getsubscriptionstatus'),
    syncSubscriptionStatus: v2Url('syncsubscriptionstatus'),
  },

  // Contact (V2)
  contact: {
    sendEmail: v2Url('sendcontactemail'),
  },

  // Email Notifications (mixed V1/V2)
  notifications: {
    enableDailyRemindersForAll: v2Url('enabledailyremindersforall'),
    disableDailyRemindersForAll: v1Url('disableDailyRemindersForAll'),
    updateUserEmailNotification: v1Url('updateUserEmailNotification'),
    testDailyDigest: v2Url('testdailydigest'),
    backfillUserEmails: v1Url('backfillUserEmails'),
    sendDigestToAll: v2Url('senddigesttoall'),
    testNudgeEmail: v2Url('testnudgeemail'),
  },

  // Timezone (V1)
  timezone: {
    setDefaultForAll: v1Url('setDefaultTimezoneForAll'),
    updateUserTimezone: v1Url('updateUserTimezone'),
  },

  // In-app assistant (V2)
  agent: {
    chat: v2Url('agentchat'),
    parse: v2Url('agentparse'),
    opening: v2Url('agentopening'), // now serves the chat's suggestions
  },

  // Affiliate (V1)
  affiliate: {
    getStats: v1Url('getAffiliateStats'),
  },
};

export default FUNCTION_URLS;
